<template>
    <div ref="mostSuspiciousProductPieChart" style="min-height: 400px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    export default {
        data () {
            return {
                chart : null,
                label : null,

                // data : [
                //     {name:"MPX 1", count:21000},
                //     {name:"MPX 2", count:19000},
                //     {name:"MPX 3", count:17000},
                //     {name:"SPX 1", count:25000},
                //     {name:"SPX 2", count:22000}
                // ]
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                // let length = this.chart.data.length;
                // if (this.data && this.data.length > 0) {
                //     let total = 0;
                //     for (var i in this.data) total += this.data[i].value;
                //     this.label.text = `Total\n${this.numberWithCommas(total)}`;
                // } else {
                //     this.label.text = "Total\n0";
                // }
                // this.chart.addData(this.data && this.data.length > 0 ? this.data : [{variant : 'No Data', value : 1}], length);

                let length = this.chart.data.length;
                if (this.data && this.data.length > 0) {
                    let total = 0;
                    for (var i in this.data) total += this.data[i].count;
                    this.label.text = `Total\n${this.numberWithCommas(total)}`;
                } else {
                    this.label.text = "Total\n0";
                }
                this.chart.addData(this.data && this.data.length > 0 ? this.data : [{name : 'No Data', count : 1}], length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.mostSuspiciousProductPieChart, am4charts.PieChart);

                this.chart.colors.list = [
                    am4core.color("#B1E5FD"),
                    am4core.color("#FFCDD1"),
                    am4core.color("#B1DFDB"),
                    am4core.color("#C3DFB1"),
                    am4core.color("#CDB1DF")
                ]

                // Add and configure Series
                let pieSeries = this.chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "count";
                pieSeries.dataFields.category = "name";

                // Let's cut a hole in our Pie chart the size of 55% the radius
                this.chart.innerRadius = am4core.percent(50);

                // Put a thick white border around each Slice
                pieSeries.slices.template.stroke = am4core.color("#fff");
                pieSeries.slices.template.strokeWidth = 2;
                pieSeries.slices.template.strokeOpacity = 1;
                pieSeries.slices.template
                // change the cursor on hover to make it apparent the object can be interacted with
                .cursorOverStyle = [
                    {
                    "property": "cursor",
                    "value": "pointer"
                    }
                ];

                pieSeries.slices.template.adapter.add("fill", (fill, target)=>{
                    return this.chart.colors.getIndex(target.dataItem.index);
                })

                pieSeries.alignLabels = false;
                // pieSeries.labels.template.bent = true;
                // pieSeries.labels.template.radius = 3;
                // pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.ticks.template.disabled = true;
                pieSeries.alignLabels = false;
                pieSeries.labels.template.text = "[bold]{value.percent.formatNumber('#.0')}%";
                pieSeries.labels.template.bent = true;
                pieSeries.labels.template.radius = am4core.percent(-25);
                pieSeries.labels.template.fill = am4core.color("#FFF");
                pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.labels.template.adapter.add("radius", (radius, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.percent(2.5);
                    } 
                    return radius;
                })

                pieSeries.labels.template.adapter.add("fill", (color, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.color("#000");
                    } 
                    return color;
                })

                // Create a base filter effect (as if it's not there) for the hover to return to
                let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
                shadow.opacity = 0;

                // Create hover state
                let hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

                // Slightly shift the shadow and make it more prominent on hover
                let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
                hoverShadow.opacity = 0.7;
                hoverShadow.blur = 5;

                // Add a legend
                this.chart.legend = new am4charts.Legend();
                this.chart.legend.useDefaultMarker = true;
                this.chart.legend.maxHeight = 100;
                this.chart.legend.scrollable = true;
                var marker = this.chart.legend.markers.template;
                // marker.cornerRadius(12, 12, 12, 12);
                marker.width = 5;
                marker.height = 20;


                // Add label
                // this.chart.innerRadius = 100;
                this.label = this.chart.seriesContainer.createChild(am4core.Label);
                this.label.text = "Total\n0";
                this.label.horizontalCenter = "middle";
                this.label.verticalCenter = "middle";
                this.label.textAlign = "middle";
                this.label.fontSize = 20;

                // let label2 = this.chart.seriesContainer.createChild(am4core.label);
                // label.text = "2000";
                // label.horizontalCenter = "middle";
                // label.verticalCenter = "bottom";
                // label.fontSize = 30;
            }   
        }
    }
</script>

<style scoped>

</style>